// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3CObT","header":"MessagesList_header__2ZxAn","chat":"MessagesList_chat__2ip_R"};